export enum GridBlockDimensions {
    SQUARE_SMALL = '1x1',
    SQUARE_BIG = '2x2',
    RECTANGLE_HORIZONTAL = '2x1',
    RECTANGLE_VERTICAL = '1x2',
}

export enum CustomerGender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}
